// extracted by mini-css-extract-plugin
export var text = "_ag-0";